// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environmentDev.ts` with `environmentDev.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js';
import { KeycloakOptions } from 'keycloak-angular';

export const appUrl = 'https://posf-beta.anre.ro';

const keycloakConfig: KeycloakConfig = {
  url: appUrl + '/auth/',
  realm: 'Anre',
  clientId: 'anre-back-office-web-app',
};

const keycloakInitOptions: KeycloakInitOptions = {
  onLoad: 'check-sso',
  checkLoginIframe: false,
};

export const keycloakOptions: KeycloakOptions = {
  config: keycloakConfig,
  initOptions: keycloakInitOptions,
  enableBearerInterceptor: true,
};

export const environment = {
  feUrl: appUrl + '/',
  production: true,
  baseUrl: appUrl + '/api/v1',
  comparatorBaseUrl: appUrl,
  comparatorDocumentsUrl: appUrl + "/comparator/files/",
  appUrl: appUrl,
  devAppUrl: appUrl,
  loggedInUrl: appUrl + '/api/v1/utilizator',
  keycloakOptions,
  botUrl: '/',
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
